export function resolveTheme(reduxTheme) {
  if (reduxTheme === 'light') return 'light'
  if (reduxTheme === 'dark') return 'dark'
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const localStorageTheme = localStorage.getItem('theme')
      if (localStorageTheme === 'light' || localStorageTheme === 'dark')
        return localStorageTheme
    }
  } catch (e) {}
  return 'dark'
}
